import { useState } from "react";
import { format, parseISO, isValid } from "date-fns";
import { it } from "date-fns/locale";
import { CalendarIcon, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const toDate = (iso) => { if (!iso) return undefined; const d = parseISO(iso); return isValid(d) ? d : undefined; };

export const DatePicker = ({ id, value, onChange, placeholder = "Scegli una data", testId }) => {
  const [open, setOpen] = useState(false);
  const date = toDate(value);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <div className="relative">
        <PopoverTrigger asChild>
          <Button id={id} type="button" variant="outline" data-testid={testId}
            className={`w-full justify-start pr-8 font-normal ${!date ? "text-slate-400" : ""}`}>
            <CalendarIcon className="mr-2 h-4 w-4 shrink-0" />
            {date ? format(date, "dd/MM/yyyy") : placeholder}
          </Button>
        </PopoverTrigger>
        {date && (
          <button type="button" onClick={() => onChange("")} aria-label="Cancella data" data-testid={testId ? `${testId}-clear` : undefined}
            className="absolute right-2 top-1/2 -translate-y-1/2 rounded p-0.5 text-slate-400 hover:text-slate-900">
            <X className="h-3.5 w-3.5" />
          </button>
        )}
      </div>
      <PopoverContent className="w-auto p-0" align="start" data-testid={testId ? `${testId}-popover` : undefined}>
        <Calendar mode="single" locale={it} selected={date} defaultMonth={date}
          captionLayout="dropdown-buttons" fromYear={1950} toYear={new Date().getFullYear() + 5}
          onSelect={(d) => { onChange(d ? format(d, "yyyy-MM-dd") : ""); setOpen(false); }} />
      </PopoverContent>
    </Popover>
  );
};
